import { Filter, FilterRemove } from '@carbon/react/icons';
import { Button } from '@carbon/react';
import { useDataTableContext } from '../context';
import styles from './table-toolbar.module.scss';

// ─────────────────────────────────────
// Component
// ─────────────────────────────────────

/**
 * Toggle button for showing/hiding inline column filters
 * @return {JSX.Element} The toggle button element
 */
export function ColumnFilterToggle() {
  const { isColumnFilterActive, setIsColumnFilterActive } =
    useDataTableContext();

  return (
    <Button
      hasIconOnly
      kind="ghost"
      size="lg"
      iconDescription={
        isColumnFilterActive ? 'Hide column filters' : 'Show column filters'
      }
      renderIcon={isColumnFilterActive ? FilterRemove : Filter}
      onClick={() => setIsColumnFilterActive(!isColumnFilterActive)}
      className={isColumnFilterActive ? styles.activeButton : undefined}
      data-testid="column-filter-toggle"
    />
  );
}
